const AssigmentsType = {
  SET_CURRENT_ASSIGMENTS: "SET_CURRENT_ASSIGMENTS",
  RESET_MY_ASSIGMENTS: "RESET_MY_ASSIGMENTS",
};

export default AssigmentsType;
